var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16.0 22.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1080 L0,1080 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.496,0 L16,1.504 L3.63733333,13.8666667 L10.6666667,13.8666667 L10.6666667,16 L0,16 L0,5.33333333 L2.13333333,5.33333333 L2.13333333,12.3626667 L14.496,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1290.0 -243.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1286.6862915010151 254.5) rotate(44.99999999999999) scale(1.0 -1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.13686838e-13 16,1.13686838e-13 16,16 0,16 0,1.13686838e-13",
    stroke: "none",
    fill: "#ffce44"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowArrowUp);
export default __webpack_public_path__ + "static/media/yellow-arrow-up.f1869f88dfcb8cecd55f202dee525540.svg";
export { ForwardRef as ReactComponent };